"use client";
import { useRecoilDisclosure } from "@areahub/ui";
import {
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";
import { ButtonProp } from "lib/gcms";
import { PropsWithChildren } from "react";
import { atom } from "recoil";
import { mapButton } from "utils/map-button";
import { v1 } from "uuid";

export interface PopUpProps {
  title: string;
  content?: string;
  buttons: ButtonProp[];
}

export const popupDisclosure = atom({
  key: `popupDisclosure/${v1()}`,
  default: false,
});

export const PopUp = ({
  title,
  content,
  buttons,
  children,
}: PropsWithChildren<PopUpProps>) => {
  const popup = useRecoilDisclosure(popupDisclosure);

  const linkToProp = buttons.find((x) => x.buttonAction !== "CLOSE_MODAL");
  const closeModalProp = buttons.find((x) => x.buttonAction === "CLOSE_MODAL");
  const LinkToButton = linkToProp ? (
    mapButton(linkToProp, {
      w: "100%",
      size: "lg",
      my: "4",
      borderRadius: "3xl",
    })
  ) : (
    <div />
  );
  const CloseModalButton = closeModalProp ? (
    mapButton(closeModalProp, { w: "100%" })
  ) : (
    <div />
  );

  return (
    <Modal
      isCentered
      onClose={popup.onClose}
      isOpen={popup.isOpen}
      scrollBehavior="outside"
      motionPreset="slideInBottom"
    >
      <ModalOverlay height="100vh" />
      <ModalContent
        position={{
          base: "fixed",
          md: "relative",
        }}
        bottom={{ base: "0px" }}
        mb="0"
        p="4"
        borderRadius={{
          base: "1.75rem 1.75rem 0px 0px",
          md: "md",
        }}
        maxW={{ base: "2xl", lg: "3xl" }}
      >
        <ModalHeader textAlign="center" fontSize="3xl">
          {title}
        </ModalHeader>
        {content && <Center textAlign="center">{content}</Center>}
        {children}
        <ModalCloseButton outline="none" _focus={{ outline: "none" }} />
        <ModalBody>
          <VStack
            textAlign="center"
            alignItems="center"
            mt="2"
            mb="4"
            spacing="4"
          >
            {LinkToButton}
            {CloseModalButton}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PopUp;
